import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 주차별 교육현황
// request data
//  - pid *required
//  - session-num
export function getEduStatusFromMomthera(request) {
    return AxiosInterceptor({
        url: '/edu/status',
        method: 'get',
        params: request
    })
}

// 사용자 치료 목표(8주 후 나의 모습) 조회하기
export function getEduGoalFromMomthera({pid}) {
    return AxiosInterceptor({
        url: '/edu/goal',
        method: 'get',
        params: {pid}
    })
}

// 최종 마무리 이미지
export function getEduGoalImgFromMomthera({pid}){
    return AxiosInterceptor({
        url: '/edu/goal-img',
        params: {pid},
        responseType: 'blob'
    })
}